import React, {
  createContext, useContext, useState, useEffect, useRef
} from 'react';
import THDCustomer from '@thd-olt-global/thd-customer';
import PropTypes from 'prop-types';
import { getCustomerRecentActivity } from './api/accountActivityLogApi';
import { activityLogEnabled } from './utils';

export function ActivityLogProvider({ children }) {

  const [loading, setLoading] = useState(true);
  const [activities, setActivities] = useState([]);

  async function fetchData() {
    if (THDCustomer?.isLoggedIn) {
      const data = await getCustomerRecentActivity();
      if (data && data?.length > 0) {
        setActivities(data);
        setLoading(false);
      }
    }
  }

  function refreshData() {
    fetchData();
  }

  useEffect(() => {
    if (activityLogEnabled()) {
      refreshData();
    }
  }, []);

  const value = {
    activities,
    loading,
    refreshData,
  };

  return (
    <ActivityLogContext.Provider value={value}>
      {children}
    </ActivityLogContext.Provider>
  );
}

export const ActivityLogContext = createContext({});

export function useActivityLogContext() {
  return useContext(ActivityLogContext);
}

ActivityLogProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
